module.exports = __webpack_public_path__ + "img/together_we.10bd8cd5.svg";